import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import Skeleton from "@/components/shared/Skeleton";
import JsonViewer from "./JsonViewer";
import { X } from "lucide-react";

const Field = ({ label, value }) => (
  <div>
    <div className="text-[11px] font-semibold text-text-primary/60 uppercase tracking-wide">{label}</div>
    <div className="text-xs text-text-primary mt-0.5 break-words">{value ?? "—"}</div>
  </div>
);

const DetailModal = ({
  open,
  onClose,
  loading,
  title,
  fields = [],
  jsonSections = [],
}) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-[720px]">
      <DialogHeader className="flex flex-row items-center justify-between border-b border-border-primary px-6 py-4">
        <DialogTitle>{title}</DialogTitle>

        <Button
          type="button"
          onClick={onClose}
          className="rounded-md p-1 text-text-secondary transition-colors hover:bg-background-tertiary hover:text-text-primary"
        >
          <X size={18} />
        </Button>
      </DialogHeader>

      <div className="max-h-[65vh] overflow-y-auto p-6 space-y-5">
        {loading ? (
          <Skeleton className="h-40 w-full" />
        ) : (
          <>
            <div className="grid grid-cols-2 gap-4">
              {fields.map(({ label, value }) => (
                <Field
                  key={label}
                  label={label}
                  value={value}
                />
              ))}
            </div>

            {jsonSections.map(
              ({ label, value }) =>
                value != null && (
                  <JsonViewer
                    key={label}
                    label={label}
                    value={value}
                  />
                )
            )}
          </>
        )}
      </div>
    </DialogContent>
  </Dialog>
);

export default DetailModal;